 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-dashboard-dashboard-module":"pages-dashboard-dashboard-module","pages-login-login-module":"pages-login-login-module","pages-password-reset-password-reset-module":"pages-password-reset-password-reset-module","pages-signup-signup-module":"pages-signup-signup-module","components-o-auth-handler-pages-loading-oauth-loading-oauth-module":"components-o-auth-handler-pages-loading-oauth-loading-oauth-module","core-js-js":"core-js-js","default~children-print-print-module~pages-sheet-view-sheet-view-module":"default~children-print-print-module~pages-sheet-view-sheet-view-module","pages-sheet-view-sheet-view-module":"pages-sheet-view-sheet-view-module","dom-js":"dom-js","pages-home-home-module":"pages-home-home-module","pages-privacy-privacy-module":"pages-privacy-privacy-module","pages-terms-terms-module":"pages-terms-terms-module","pages-ticket-view-ticket-view-module":"pages-ticket-view-ticket-view-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-7f9c6860-js":"shadow-css-7f9c6860-js","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","swiper-bundle-95afeea2-js":"swiper-bundle-95afeea2-js","focus-visible-15ada7f7-js":"focus-visible-15ada7f7-js","input-shims-d4609e0d-js":"input-shims-d4609e0d-js","keyboard-a2b5e51d-js":"keyboard-a2b5e51d-js","status-tap-171795fe-js":"status-tap-171795fe-js","swipe-back-0a6a44c8-js":"swipe-back-0a6a44c8-js","tap-click-252af35a-js":"tap-click-252af35a-js","children-my-profile-my-profile-module":"children-my-profile-my-profile-module","children-pending-pending-module":"children-pending-pending-module","default~children-client-client-module~children-notifications-notifications-module~children-staff-staff-module":"default~children-client-client-module~children-notifications-notifications-module~children-staff-staff-module","children-client-client-module":"children-client-client-module","children-notifications-notifications-module":"children-notifications-notifications-module","children-staff-staff-module":"children-staff-staff-module","default~children-add-add-module~children-details-details-module~children-edit-edit-module~children-e~c1b405e0":"default~children-add-add-module~children-details-details-module~children-edit-edit-module~children-e~c1b405e0","default~children-add-add-module~children-details-details-module~children-edit-edit-module~children-e~4287aa68":"default~children-add-add-module~children-details-details-module~children-edit-edit-module~children-e~4287aa68","children-entity-entity-module":"children-entity-entity-module","children-organization-organization-module":"children-organization-organization-module","default~children-equipments-equipments-module~children-list-list-module~children-processes-processes~4a7698e2":"default~children-equipments-equipments-module~children-list-list-module~children-processes-processes~4a7698e2","children-products-products-module":"children-products-products-module","children-tickets-tickets-module":"children-tickets-tickets-module","children-equipments-equipments-module":"children-equipments-equipments-module","children-clients-clients-module":"children-clients-clients-module","children-inventory-inventory-module":"children-inventory-inventory-module","children-departments-departments-module":"children-departments-departments-module","children-roles-roles-module":"children-roles-roles-module","children-settings-settings-module":"children-settings-settings-module","children-users-users-module":"children-users-users-module","children-summary-summary-module":"children-summary-summary-module","children-details-details-module":"children-details-details-module","children-add-add-module":"children-add-add-module","children-edit-edit-module":"children-edit-edit-module","children-list-list-module":"children-list-list-module","children-sheets-sheets-module":"children-sheets-sheets-module","children-bills-bills-module":"children-bills-bills-module","children-sales-sales-module":"children-sales-sales-module","children-support-support-module":"children-support-support-module","children-egress-egress-module":"children-egress-egress-module","children-ingress-ingress-module":"children-ingress-ingress-module","children-utils-utils-module":"children-utils-utils-module","children-info-info-module":"children-info-info-module","children-storage-storage-module":"children-storage-storage-module","children-processes-processes-module":"children-processes-processes-module","children-branches-branches-module":"children-branches-branches-module","children-print-print-module":"children-print-print-module","add-add-module":"add-add-module","edit-edit-module":"edit-edit-module","list-list-module":"list-list-module","info-info-module":"info-info-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
